import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';

import loguito from '../../static/loguito.svg'
import ServicesAsis from '../../static/servicesAsis.json'

import '../../scss/header.scss'

import ComingSoon from '../../../shared/status/ComingSoon.svg'

const {
    REACT_APP_STUDENT
} = process.env;

interface Service {
    id: string
    title: string
    description: string
    icon: string
    image?: string
    main_information?: any
}

interface IProps {
    moverseA: (id: string) => void
}

const Header = ({ moverseA }: IProps): JSX.Element => {

    const servicesAsis: Service[] = ServicesAsis

    const [services, setServices] = useState<boolean>(false)
    const [typeService, setTypeService] = useState<string>('')
    const [subservices, setsubservices] = useState<number>(0)

    // Burger
    const [burger, setBurger] = useState<boolean>(false)
    const [servicesB, setServicesB] = useState<boolean>(false)
    const [typeServiceB, setTypeServiceB] = useState<string>('')
    //

    const [loader, setLoader] = useState<boolean>(false)
    
    const [generalCourses, setGeneralCourses] = useState<any[]>([])
    console.log(loader,generalCourses)

    const history = useHistory();

    const restoreValues = () => {
        setServices(false)
        setTypeService('')
        setsubservices(0)
        // Burger
        setBurger(false)
        setServicesB(false)
        setTypeServiceB('')
        //
    }

    const selectOpt = (opt: string) => {
        if (opt === typeServiceB) {
            setTypeServiceB('')
        }
        else {
            setTypeServiceB(opt)
        }
    }

    const redirectLogin = () => history.push('/auth/login');

    useEffect(() => {
        setLoader(false)
        const id = '60a2adea74a07200190effd2'
        const url = `${REACT_APP_STUDENT}/v5.0.1`
        const data = {
            fname: 'getCourses_byEntity',
            entity_id: id,
            // docs: '8',
            // page: '1'
        }
        axios({
            url: url,
            data: data,
            method: 'POST'
        })
            .then(({ data }) => {
                // console.log('header', data)
                setGeneralCourses(data.courses)
                // setGeneralCourses([])
                setLoader(true)
            })
            .catch(({ response }) => {
                console.log(response)
                setLoader(true)
            })
    }, [])

    return (
        <>
            <header className="container-Header">
                <div className="contentHeader">
                    <Link to="/">
                        <img src={loguito} alt="img Entity" onClick={restoreValues} />
                    </Link>
                    <div className="Navigate">
                        <div className="optNavigate" >
                            <Link to="/">
                                <span onClick={restoreValues}>Inicio</span>
                            </Link>
                            <span onClick={() => setServices(!services)}>Servicios</span>
                            <span onClick={() => moverseA('contactanos')}>Contáctanos</span>
                            <button onClick={redirectLogin} >Iniciar Sesión</button>
                        </div>
                        <i className="far fa-user" style={{ fontSize: "25px", marginRight: "10px" }} onClick={redirectLogin} />
                        <i className="fas fa-bars" onClick={() => setBurger(true)} />
                    </div>
                </div>
            </header>
            <div className={`menuburger ${burger ? 'active' : ''}`}>
                <div className="burgerHEad">
                    <img src={loguito} alt="lgEtt" />
                    <i className="fas fa-times" onClick={() => setBurger(false)} />
                </div>
                <div className="burgerBody">
                    <div className="itmOpst" onClick={restoreValues}>
                        <Link to="/">
                            <p>Inicio</p>
                        </Link>
                    </div>
                    <div className="itmOpst">
                        <p className={`tosTitle ${servicesB ? 'active' : ''}`} onClick={() => setServicesB(!servicesB)}>
                            Servicios <i className={`fas fa-chevron-${servicesB ? 'up' : 'down'}`} />
                        </p>
                        {
                            servicesB &&
                            <div className="allstvs">
                                <div>
                                    <p className={`tosTitle ${typeServiceB === 'academics' ? 'active' : ''}`} onClick={() => selectOpt('academics')}>
                                        Servicios académicos <i className={`fas fa-chevron-${typeServiceB === 'academics' ? 'up' : 'down'}`} />
                                    </p>
                                    {
                                        typeServiceB === 'academics' &&
                                        <div className="infcur">
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '5px'
                                            }}>
                                                <div style={{ fontFamily: 'system-ui', fontWeight: 'bold', fontSize: '24px' }}>¡Proximamente!</div>
                                                <div
                                                    style={{
                                                        fontFamily: 'Poppins',
                                                        fontSize: '16px'
                                                    }}
                                                >Nuestros servicios académicos están en construcción.</div>
                                            </div>
                                            {/* {
                                                !loader ? <h4>Cargando...</h4> :
                                                    !generalCourses.length ? <h4>Sin servicios Académicos</h4> :
                                                        generalCourses.map((data, key) => {
                                                            const { _id, name } = data
                                                            return (
                                                                <Link to={`/service/academic/${_id}`} onClick={restoreValues} key={key}>
                                                                    <div className={`itemAcad ${subservices === key + 1 ? 'active' : ''}`}
                                                                    >
                                                                        <p>{name}</p>
                                                                    </div>
                                                                </Link>
                                                            )
                                                        })
                                            }
                                            {
                                                loader &&
                                                <Link to='/service/academic' onClick={restoreValues} className="shwmore">
                                                    <i className="fas fa-plus" /><p>Ver todos</p>
                                                </Link>
                                            } */}
                                        </div>
                                    }
                                </div>
                                <div>
                                    <p className={`tosTitle ${typeServiceB === 'assistance' ? 'active' : ''}`} onClick={() => selectOpt('assistance')}>
                                        Servicios asistenciales <i className={`fas fa-chevron-${typeServiceB === 'assistance' ? 'up' : 'down'}`} />
                                    </p>
                                    {
                                        typeServiceB === 'assistance' &&
                                        <div className="infcur">
                                            {
                                                servicesAsis.map((data, key) => {
                                                    const { id, description, title, image, main_information } = data
                                                    return (
                                                        <div key={key} className={`itemAcad Asis ${subservices === key + 1 ? 'active' : ''}`}
                                                        >
                                                            <Link to={{
                                                                pathname: `/service/assistance/${title}`,
                                                                state: { id: id, title: title, description: description, image: image, main_information: main_information }
                                                            }}
                                                                onClick={restoreValues} key={key}>
                                                                <div className="nitm">
                                                                    <p>{data.title}</p>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    )
                                                })
                                            }
                                            {
                                                <Link to='/service/assistance' onClick={restoreValues} className="shwmore">
                                                    <i className="fas fa-plus" /><p>Ver todos</p>
                                                </Link>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    <div className="itmOpst" onClick={restoreValues}>
                        <p onClick={() => moverseA('contactanos')}>Contáctanos</p>
                    </div>
                </div>
                <div className="brline">
                    <hr />
                </div>
                <div className="burgerFooter">
                    <button onClick={redirectLogin} >Iniciar Sesión</button>
                </div>
            </div>
            {
                services &&
                <div className="menuservices"
                onMouseLeave={() => setServices(!services)}
                >
                    <div>
                        <div className="titser">Servicios</div>
                        <div className="opstser">
                            <div className={`itemSer`}
                                onMouseEnter={() => setTypeService('academics')}
                            onMouseLeave={() => setTypeService('')}
                            >
                                {/* <Link to='/service/academic' onClick={restoreValues} className={`itemSer ${typeService === 'academics' ? 'active' : ''}`}> */}
                                <Link to='' onClick={ (e) => e.preventDefault() } className={`itemSer ${typeService === 'academics' ? 'active' : ''}`}>
                                    <p>Servicios académicos</p> <i className="fas fa-chevron-right" />
                                </Link>
                                {
                                    typeService === 'academics' &&
                                    <div className="containerServices" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '20px',
                                                width: '100%',
                                                maxWidth: '432px',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <img src={ComingSoon} alt="Notice page" width='120px' />
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '5px'
                                                }}
                                            >
                                                <div style={{ fontFamily: 'system-ui', fontWeight: 'bold', fontSize: '32px' }}>¡Proximamente!</div>
                                                <div
                                                    style={{
                                                        fontFamily: 'Poppins',
                                                        fontSize: '16px'
                                                    }}
                                                >Nuestros servicios académicos están en construcción.</div>
                                            </div>
                                        </div>
                                    </div>
                                    // <div className="containerServices">
                                    //     {
                                    //         !loader ? <h4>Cargando...</h4> :
                                    //             !generalCourses.length ? <h4>Sin servicios Académicos</h4> :
                                    //                 generalCourses.slice(0, generalCourses.length > 8 ? 7 : generalCourses.length).map((data, key) => {
                                    //                     const { _id, name, preview } = data
                                    //                     return (
                                    //                         <Link to={`/service/academic/${_id}`} onClick={restoreValues} key={key}>
                                    //                             <div className={`itemAcad ${subservices === key + 1 ? 'active' : ''}`}
                                    //                                 onMouseEnter={() => setsubservices(key + 1)}
                                    //                                 onMouseLeave={() => setsubservices(0)}
                                    //                             >
                                    //                                 <p>{name}</p>
                                    //                                 {
                                    //                                     subservices === key + 1 &&
                                    //                                     <div className="infoAcad">
                                    //                                         <img src={preview} alt="aaa" />
                                    //                                         <div>
                                    //                                             Más información <i className="fas fa-chevron-right" />
                                    //                                         </div>
                                    //                                     </div>
                                    //                                 }
                                    //                             </div>
                                    //                         </Link>
                                    //                     )
                                    //                 })
                                    //     }
                                    //     {
                                    //         loader &&
                                    //         generalCourses.length > 8 &&
                                    //         <Link to='/service/academic' onClick={restoreValues} className="shwmore">
                                    //             <i className="fas fa-plus" /><p>Servicios académicos</p>
                                    //         </Link>
                                    //     }
                                    // </div>
                                }
                            </div>
                            <div className={`itemSer`}
                                onMouseEnter={() => setTypeService('assistance')}
                                onMouseLeave={() => setTypeService('')}
                            >
                                <Link to='/service/assistance' onClick={restoreValues} className={`itemSer ${typeService === 'assistance' ? 'active' : ''}`}>
                                    <p>Servicios asistenciales</p> <i className="fas fa-chevron-right" />
                                </Link>
                                {
                                    typeService === 'assistance' &&
                                    <div className="containerServices">
                                        {
                                            servicesAsis.slice(0, servicesAsis.length > 8 ? 7 : servicesAsis.length).map((data, key) => {
                                                const { id, description, title, image, main_information } = data
                                                return (
                                                    <div key={key} className={`itemAcad Asis ${subservices === key + 1 ? 'active' : ''}`}
                                                        onMouseEnter={() => setsubservices(key + 1)}
                                                        onMouseLeave={() => setsubservices(0)}
                                                    >
                                                        <Link to={{
                                                            pathname: `/service/assistance/${title}`,
                                                            state: { id: id, title: title, description: description, image: image, main_information: main_information }
                                                        }}
                                                            onClick={restoreValues} key={key}>
                                                            <div className="nitm">
                                                                <p>{key + 1}) {data.title}</p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                )
                                            })
                                        }
                                        {
                                            servicesAsis.length > 8 &&
                                            <Link to='/service/assistance' onClick={restoreValues} className="shwmore">
                                                <i className="fas fa-plus" /><p>Servicios asistenciales</p>
                                            </Link>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default Header
